import * as React from 'react';

export type AuroraGlassIntensity = 'subtle' | 'medium' | 'strong';

export interface AuroraGlassPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  intensity?: AuroraGlassIntensity;
  as?: 'div' | 'header' | 'aside' | 'section';
}

const INTENSITY: Record<AuroraGlassIntensity, string> = {
  subtle:
    'bg-white/70 dark:bg-gray-900/60 backdrop-blur-sm border border-white/40 dark:border-white/10 ' +
    'before:bg-gradient-to-br before:from-indigo-500/[0.04] before:via-transparent before:to-violet-500/[0.04]',
  medium:
    'bg-white/60 dark:bg-gray-900/55 backdrop-blur-md border border-white/50 dark:border-white/[0.12] ' +
    'before:bg-gradient-to-br before:from-indigo-500/[0.07] before:via-transparent before:to-violet-500/[0.07]',
  strong:
    'bg-white/50 dark:bg-gray-900/45 backdrop-blur-xl border border-white/60 dark:border-white/[0.14] ' +
    'before:bg-gradient-to-br before:from-indigo-500/[0.10] before:via-fuchsia-500/[0.04] before:to-violet-500/[0.10]',
};

// Task #1665 — pannello glass Aurora riusabile (Chat sidebar, Feed sidebar,
// header workgroup hub, header feed page). Usa backdrop-blur + bordo
// semitrasparente + gradient sottile aurora via pseudo-elemento before.
export const AuroraGlassPanel = React.forwardRef<HTMLDivElement, AuroraGlassPanelProps>(
  function AuroraGlassPanel({ intensity = 'medium', as = 'div', className = '', children, ...rest }, ref) {
    const Tag = as as 'div';
    return (
      <Tag
        ref={ref as React.Ref<HTMLDivElement>}
        className={
          'relative isolate overflow-hidden ' +
          'before:absolute before:inset-0 before:-z-10 before:pointer-events-none ' +
          INTENSITY[intensity] +
          (className ? ' ' + className : '')
        }
        {...rest}
      >
        {children}
      </Tag>
    );
  }
);
